export default "__VITE_PUBLIC_ASSET__3213f23a__"